import * as React from 'react';
import Box from '@mui/material/Box';

const Content = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box sx={{ py: { xs: 2, sm: 2, md: 6, lg: 6 }, px: { xs: 1, sm: 1, md: 4, lg: 20 } }}>
      {children}
    </Box>
  );
};

export default Content;
